export default {
    manage_inputs: "Etiquetas de Entradas",
    manage_inputs_columTitle: "Etiqueta de Entrada",
    manage_inputs_onLabel: "Etiqueta ON",
    manage_inputs_offLabel: "Etiqueta OFF",
    manage_inputs_search_by_input_label: "Buscar por Etiqueta de Entrada"
}